import { Link } from 'react-router-dom';
import { UsersIcon, CheckIcon, ClockIcon, AlertIcon } from './icons.jsx';

/**
 * Dashboard stat cards grid.
 * @param {{ total: number, delivered: number, pending: number, problems: number }} props
 */
export default function DashboardStats({ total, delivered, pending, problems }) {
  const cards = [
    {
      to: '/clients',
      value: total,
      label: 'Clients',
      Icon: UsersIcon,
      color: 'text-[var(--color-accent)]',
      bg: 'bg-blue-50',
    },
    {
      to: '/clients?status=pending',
      value: pending,
      label: 'À livrer',
      Icon: ClockIcon,
      color: 'text-[var(--color-neutral)]',
      bg: 'bg-gray-50',
    },
    {
      value: delivered,
      label: 'Livrés',
      Icon: CheckIcon,
      color: 'text-[var(--color-success)]',
      bg: 'bg-emerald-50',
    },
    {
      value: problems,
      label: 'Problèmes',
      Icon: AlertIcon,
      color: 'text-[var(--color-error)]',
      bg: 'bg-red-50',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {cards.map((card) => {
        const inner = (
          <>
            <div className={`w-9 h-9 rounded-lg ${card.bg} flex items-center justify-center mb-2`}>
              <card.Icon size={18} className={card.color} />
            </div>
            <div className={`text-2xl font-bold ${card.color}`}>{card.value}</div>
            <div className="text-xs text-[var(--color-neutral)] mt-0.5">{card.label}</div>
          </>
        );

        const cls = 'bg-white rounded-xl p-4 shadow-[var(--shadow-sm)] hover:shadow-[var(--shadow-md)]';

        if (card.to) {
          return (
            <Link key={card.label} to={card.to} className={cls}>
              {inner}
            </Link>
          );
        }
        return (
          <div key={card.label} className={cls}>
            {inner}
          </div>
        );
      })}
    </div>
  );
}
